/* ig-pdp-info-first.js  v6  2026-08-27
   Mobile product page: put the buying information ABOVE the photo.

   Larry, 27 Aug: "can you move rings, product description and price at the top
   of the photo" then "no i think leave the description at the bottom of the
   photo". So: category tag, title, price and tax line go up; the long
   description stays where the theme put it, under the gallery.

   WHY v6 IS DIFFERENT (this is the important bit)
   -----------------------------------------------
   v5 MOVED the price node out of .product__detail. That broke variant pricing.
   The theme's <variant-selects> re-renders the product section and writes the
   new price into .product__detail; once the price node had been moved out of
   that region the new markup landed on a node nobody could see, so tapping a
   different carat weight changed the variant but never the number on screen.

   v6 does not move the price. The theme's own price block stays exactly where
   the theme put it (hidden on mobile by CSS) and keeps receiving updates. We
   render a MIRROR of it inside the lead block and copy the markup across
   whenever it changes. Variant switching therefore works untouched.

   Title and category tag ARE still moved - they never change per variant.
   Their originals are hidden by CSS as well, so if the theme re-renders the
   section and restores copies of them inside .product__detail, no duplicate
   ever becomes visible.

   Mobile only (<=768px), product template only. Reverses itself on desktop.
   REVERT: delete this file and remove its <script> from snippets/preload.liquid. */
(function () {
  'use strict';

  var MQ = '(max-width: 768px)';
  var MOVE_BEFORE = ['.type_tag', '.product__title'];
  var MOVE_AFTER  = ['.product__tax'];

  var lead = null;
  var mirror = null;
  var moved = [];
  var observer = null;
  var bound = false;

  function mql() { return window.matchMedia && window.matchMedia(MQ).matches; }
  function srcPrice() { return document.querySelector('.product__detail .price_availability_blocks'); }

  /* copy the theme's live price markup into the mirror */
  function syncPrice() {
    if (!mirror) return;
    var src = srcPrice();
    if (!src) return;
    var html = src.innerHTML;
    if (mirror.innerHTML === html) return;   /* fixpoint: stops observer recursion */
    mirror.innerHTML = html;
  }

  function grab(sel) {
    var el = document.querySelector('.product__detail ' + sel) || document.querySelector(sel);
    if (!el || !lead || lead.contains(el)) return;
    moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
    lead.appendChild(el);
  }

  function move() {
    if (!mql()) { unmove(); return; }

    var inner = document.querySelector('.main__product-inner');
    var gallery = document.querySelector('.inner_gallery_container');
    if (!inner || !gallery) return;

    if (lead && lead.isConnected) { syncPrice(); stick(); return; }

    lead = document.createElement('div');
    lead.className = 'ig-pdp-lead';

    MOVE_BEFORE.forEach(grab);

    mirror = document.createElement('div');
    mirror.className = 'ig-pdp-lead__price price_availability_blocks';
    lead.appendChild(mirror);

    MOVE_AFTER.forEach(grab);

    inner.insertBefore(lead, gallery);
    document.body.classList.add('ig-lead-on');

    syncPrice();
    watch();
    stick();
  }

  function unmove() {
    if (observer) { observer.disconnect(); observer = null; }
    for (var i = moved.length - 1; i >= 0; i--) {
      var m = moved[i];
      if (m.parent) m.parent.insertBefore(m.el, m.next);
    }
    moved = [];
    if (lead && lead.parentNode) lead.parentNode.removeChild(lead);
    lead = null;
    mirror = null;
    document.body.classList.remove('ig-lead-on');
  }

  /* watch the theme's own product block for any re-render, then re-mirror */
  function watch() {
    if (!window.MutationObserver) return;
    var host = document.querySelector('.main__product-inner') || document.body;
    observer = new MutationObserver(function () { syncPrice(); });
    observer.observe(host, { childList: true, subtree: true, characterData: true });

    /* belt and braces: variant-selects fetches a section render, so also poll
       briefly after any option change in case the swap lands outside the host */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name || t.name.indexOf('options[') !== 0) return;
      [120, 350, 800, 1500].forEach(function (ms) { setTimeout(syncPrice, ms); });
    }, true);
  }

  /* compact the lead once it reaches the sticky header */
  function stick() {
    if (!lead) return;
    var top = lead.getBoundingClientRect().top;
    if (top <= 69) lead.classList.add('is-stuck');
    else lead.classList.remove('is-stuck');
  }

  function bind() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', function () { stick(); }, { passive: true });
    window.addEventListener('resize', function () { move(); stick(); });
    if (window.matchMedia) {
      var m = window.matchMedia(MQ);
      if (m.addEventListener) m.addEventListener('change', move);
      else if (m.addListener) m.addListener(move);
    }
  }

  function init() { move(); bind(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
}());
